export default {
    title: 'Quản lý tuyển sinh',
    api_url: process.env.REACT_APP_API_BASE_URL,
    home_url:  process.env.REACT_APP_PORTAL_URL,
    sub_system_id: 1
};
